<!--
 * @Auther: 罗耀祖
 * @Date: 2021-07-07 18:53:40
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2021-07-07 20:44:18
 * @name: 商品管理模块路由
 * @Description: 商品管理模块路由
 * @FilePath: \backstage\src\views\goodsManage\goodsManageRouter.vue
 * @Author: DESKTOP-1QU67QM
-->
<template>
  <keep-alive :include="cashRouters">
    <router-view></router-view>
  </keep-alive>
</template>

<script>
export default {
  name: 'goodsManageRouter',
  computed: {
    cashRouters() {
      return this.$store.state.cashView.cashRouters;
    },
  },
}
</script>